import React from "react";
import "../css/Myskills.scss";
import { TiHtml5, TiCss3 } from "react-icons/ti";
import { DiSass, DiJavascript1, DiNodejs, DiDjango } from "react-icons/di";
import { AiFillGitlab } from "react-icons/ai";
import {
  SiTypescript,
  SiTailwindcss,
  SiReact,
  SiExpress,
  SiPostgresql,
  SiPython,
  SiGooglecloud,
  SiWordpress,
  SiDocker,
} from "react-icons/si";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: false,
};

const settings_moblie = {
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: false,
};

const MySkills = () => {
  return (
    <div className="my-skills">
      <h1 className="title">MySkills</h1>
      <Slider {...settings} className="slider">
        <TiHtml5 size={120} />
        <TiCss3 size={120} />
        <DiSass size={120} />
        <DiJavascript1 size={120} />
        <SiTypescript size={120} />
        <SiTailwindcss size={120} />
        <SiReact size={120} />
        <SiExpress size={120} />
        <DiNodejs size={120} />
        <SiPostgresql size={120} />
        <SiPython size={120} />
        <DiDjango size={120} />
        {/* <img
          src="https://img.icons8.com/material-outlined/96/null/api-settings.png"
          className="restful-api"
          alt="restfulApi"
        /> */}
        <SiGooglecloud size={150} />
        <SiWordpress size={150} />
        <AiFillGitlab size={150} />
        <SiDocker size={150} />
      </Slider>

      <Slider {...settings_moblie} className="slider-mobile">
        <TiHtml5 size={100} />
        <TiCss3 size={100} />
        <DiSass size={100} /> 
        <DiJavascript1 size={100} />
        <SiTypescript size={100} />
        <SiTailwindcss size={100} />
        <SiReact size={100} />
        <SiExpress size={100} />
        <DiNodejs size={100} />
        <SiPostgresql size={100} />
        <SiPython size={100} />
        <DiDjango size={100} />
        {/* <img
          src="https://img.icons8.com/material-outlined/96/null/api-settings.png"
          className="restful-api"
          alt="restfulApi"
        /> */}
        <SiGooglecloud size={130} />
        <SiWordpress size={130} />
        <AiFillGitlab size={130} />
        <SiDocker size={130} />
      </Slider>
    </div>
  );
};

export default MySkills;
